'use client';

import { SectionContainer } from '@/components/ui';
import { Skeleton } from '@/components/ui/Skeleton';

export function ViolationHistorySectionSkeleton() {
  return (
    <>
      {/* Violation History Header and Chart Skeleton */}
      <SectionContainer>
        <div className="flex items-start gap-2 mb-2">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-4 w-4 rounded-full" />
        </div>
        <Skeleton className="h-5 w-full max-w-md mb-6" />

        <div className="flex flex-col sm:flex-row gap-8 items-center">
          {/* Donut chart skeleton */}
          <div className="flex justify-center">
            <Skeleton className="w-[267px] h-[267px] rounded-full" />
          </div>

          {/* Legend skeleton */}
          <div className="flex-1 space-y-3 pt-6 sm:pt-0">
            {[1, 2, 3, 4].map(i => (
              <div key={i} className="flex items-center gap-3">
                <Skeleton className="w-3 h-3 rounded-full shrink-0" />
                <Skeleton className="h-4 w-60" />
              </div>
            ))}
          </div>
        </div>
      </SectionContainer>

      {/* Violation History Per Unit Skeleton */}
      <SectionContainer>
        <Skeleton className="h-7 w-64 mb-2" />

        {/* Year filters skeleton */}
        <div className="flex gap-2 mb-4 flex-wrap">
          {[1, 2, 3, 4, 5].map(i => (
            <Skeleton key={i} className="h-10 w-16 rounded-lg" />
          ))}
        </div>

        <Skeleton className="h-5 w-full max-w-md mb-6" />

        {/* Units list skeleton */}
        <div className="space-y-3">
          {[1, 2].map(i => (
            <div key={i} className="flex items-center gap-3 p-3 rounded-lg">
              <Skeleton className="w-5 h-5 rounded shrink-0" />
              <Skeleton className="h-5 flex-1" />
            </div>
          ))}
        </div>

        <Skeleton className="h-5 w-32 mt-4" />
      </SectionContainer>
    </>
  );
}
